module.exports = __webpack_public_path__ + "img/电梯动画3.f7517cb6.png";